import { useState, useEffect } from 'react';

/**
 * 端内全屏hooks
 * @returns {Number} 状态栏高度
 */
export const useMaximize = () => {
    const [statusBarHeight, setStatusBarHeight] = useState(0);

    useEffect(() => {
        if (window.grounds && window.grounds.maximization && window.grounds.getStatusBarHeight) {
            // 判断机型
            const isAndroid = /android/i.test(window.grounds.getDeviceInfo().getOs());
            // 机型为安卓的情况下，获取的状态栏高度需要除以屏幕像素比
            const ratio = isAndroid ? window.devicePixelRatio : 1;
            // 计算真实的状态栏高度
            const statusBarHeight = window.grounds.getStatusBarHeight() / ratio;

            // 全屏
            window.grounds.maximization();
            // 设置状态栏真实高度
            setStatusBarHeight(statusBarHeight);
        }

        // 端内阻止iOS浏览器自带下拉刷新
        if (window.grounds && window.grounds.disableBounceEffect) {
            window.grounds.disableBounceEffect('close');
        }
    }, []);

    return statusBarHeight;
};

/**
 * 端内日夜间模式hooks
 * @returns {Boolean} 是否是夜间模式
 */
export const useNightMode = () => {
    const [isNightMode, setIsNightMode] = useState(false);

    useEffect(() => {
        if (window.grounds) {
            const nightMode = 'night';

            if (window.grounds.getShowMode) {
                // 首次判断是否处于黑夜模式
                setIsNightMode(window.grounds.getShowMode() === nightMode);
            }

            if (window.grounds.on) {
                // 监听判断是否处于黑夜模式
                const showModeCallback = 'showModeCallback';

                window[showModeCallback] = current => {
                    setIsNightMode(current === nightMode);
                };

                window.grounds.on('theme', showModeCallback);
            }
        }
    }, []);

    return isNightMode;
};
